// User Specific Storage Identifiers
export const BOI_WALLET_USER_STORAGE = 'BOIWalletUser';
export const BOI_WALLET_USER_NAME_STORAGE = 'BOIWalletUserName';
export const SIGN_UP_PAGE_EMAIL_STORAGE = 'signUpPageEmail';
export const BOI_WALLET_FORM_COMPLETED = 'walletFormCompleted'
